import {GoogleAdsIcon, IntegrationCard} from "@tinct/web-components";
import {useGetCurrentWorkspaceId, useCurrentWorkspaceUrlPrefix} from "@tinct/core-workspace";
import {useDeleteCrmIntegration, useGetOrganizationById} from "@tinct/core-api";
import {useConfig} from "@tinct/core-config";
import {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {useOAuthPopup} from "../pages/edit-integrations-page/hooks/use-oauth-popup";

export const GoogleAdsIntegration = () => {
  const workspaceId = useGetCurrentWorkspaceId();
  const workspaceUrlPrefix = useCurrentWorkspaceUrlPrefix();
  const navigate = useNavigate();
  const {isFeatureEnabled} = useConfig();

  const { mutate: deleteCrmIntegration } = useDeleteCrmIntegration();
  const { openOAuthPopup } = useOAuthPopup({
    organizationId: workspaceId,
    provider: 'google_ads',
  });

  const { data: organization } = useGetOrganizationById({
    id: workspaceId,
    fields: {
      crmIntegrations: {
        fields: {
          id: null,
          providerType: null,
          status: null,
          errorDetails: null,
        }
      }
    }
  }, {
    enabled: !!workspaceId,
  });

  const googleAdsIntegration = useMemo(() => {
    return organization?.crmIntegrations?.find(integration => integration.providerType === 'google_ads');
  }, [organization]);

  const connected = !!googleAdsIntegration;

  const handleDisconnect = () => {
    if (!workspaceId || !googleAdsIntegration?.id) return;
    deleteCrmIntegration({
      integrationId: googleAdsIntegration.id,
      organizationId: workspaceId,
    })
  }

  // Feature-flagged rollout: no tile at all while the workspace's
  // google_ads_integration flag is off. (After every hook — the flag flips
  // when the config loads.)
  if (!isFeatureEnabled('googleAdsIntegration')) return null;

  return <IntegrationCard
    title="Google Ads"
    description="Serve a dedicated page variant to visitors from each ads campaign"
    status={connected ? "connected" : "not-connected"}
    icon={<GoogleAdsIcon width={40} height={40}/>}
    active={true}
    enabled={connected}
    // The switch stays connect/disconnect (matching every other tile);
    // auto-generate has its own toggle on the detail page.
    onEnabledChange={(enabled) => {
      if (enabled) {
        openOAuthPopup();
      } else {
        handleDisconnect();
      }
    }}
    onSettingsClick={
      connected && googleAdsIntegration?.id
        ? () =>
            navigate(
              `${workspaceUrlPrefix}/settings/integrations/google-ads/${googleAdsIntegration.id}`
            )
        : undefined
    }
  />
}
